// import AnalysisChart from "./AnalysisChart";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Dropdown, Menu, Pagination, Table } from "antd";
import moment from "moment";

import summaryApi from "../../apis/Summary.api";
import LinkComponent from "../../components/layout/LinkComponent";
import { setLoading } from "../../redux/store/common/commonDuck";

import AnalysisNav from "./AnalysisNav";
// import queryLogApi from "../../apis/QueryLog.api";

const AnalysisProducts = () => {
	const history = useHistory();
	const dispatch = useDispatch();

	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	useEffect(() => {
		window.scrollTo({
			top: 0,
		});
	}, []);

	const convertProduct = (item) => {
		return (
			<>
				{item?.brand_name} > <b>{item?.product_name}</b>
			</>
		);
	};

	const pageSize = 10;
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const [totalSize, setTotalSize] = useState(0);

	const [productList, setProductList] = useState([]);

	const [order, setOrder] = useState({
		orderType: "created_at",
		orderBy: "desc",
	});

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	useEffect(() => {
		if (user?.id) {
			getAnalysisProducts();
		}
	}, [user, currentPageNumber, order]);

	const getAnalysisProducts = useCallback(async () => {
		setIsLoading(true);
		const param = {
			offset: (currentPageNumber - 1) * pageSize,
			pageSize: pageSize,
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			orderType: order.orderType,
			orderBy: order.orderBy,
		};
		const res = await summaryApi.readAnalysisProductsList(param);
		if (res.code === 200) {
			setTotalSize(res.result?.total_cnt ?? 0);
			let list = res.result?.productsDTOList ?? [];
			if (list?.length) {
				list = list.map((item) => ({
					...item,
					content_id: `${item.user_id}_${item?.product_id}`,
				}));
				setProductList(list);
			} else {
				setProductList([]);
			}
		}
		setIsLoading(false);
	}, [currentPageNumber, order]);

	/**
	 * page 넘김
	 */
	const handleChangePagination = async (pageNumber) => {
		// const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
	};
	const analysisProductColumn = mediaResult
		? [
				{
					title: "",
					dataIndex: "",
					key: "title",
					width: "100%",
					ellipsis: true,
					align: "left",
					render: (value) => {
						return (
							<div className={`analysis-mobile-div`}>
								{/*<p>*/}
								{/*    {value?.category_name}*/}
								{/*</p>*/}
								<p
									className={`analysis-mobile-title`}
									style={{
										fontWeight: "500",
									}}
								>
									{convertProduct(value)}
								</p>
								<div className={`analysis-data-mobile-div`}>
									<div
										style={{
											display: "flex",
											gap: "3px",
											alignItems: "center",
										}}
									>
										<p>클릭수 {value?.product_count?.toLocaleString()}회</p>
										{/*<p>·</p>*/}
										{/*<p>{moment(moment(value?.created_at), 'YYYY.MM.DD').fromNow()}</p>*/}
										{/*<p>·</p>*/}
										{/*<p>*/}
										{/*    <img*/}
										{/*        src={`/assets/images/channel/comment.png`}*/}
										{/*        alt={`커뮤니티 아이콘`}*/}
										{/*    />{value?.comment_num}*/}
										{/*</p>*/}
									</div>
								</div>
							</div>
						);
					},
				},
		  ]
		: [
				{
					title: "브랜드명 > 상품명",
					dataIndex: "",
					key: "",
					width: "50%",
					ellipsis: true,
					render: (value) => {
						return (
							<div style={{ display: "flex", gap: 5 }}>
								{/*{value?.category_name && (*/}
								{/*    <p className={`table-category-id`}>*/}
								{/*        {value?.category_name}*/}
								{/*    </p>*/}
								{/*)}*/}
								{convertProduct(value)}
							</div>
						);
					},
				},
				{
					title: () => (
						<span
							onClick={() => {
								if (order.orderType !== "created_at") {
									setOrder({
										...order,
										orderType: "created_at",
									});
								} else {
									setOrder({
										orderType: "created_at",
										orderBy: order.orderBy === "desc" ? "asc" : "desc",
									});
								}
							}}
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "flex-start",
								gap: "3px",
								cursor: "pointer",
							}}
						>
							{order.orderType === "created_at" ? <b>등록일</b> : "등록일"}
							<img
								src={`/assets/images/products/dropdown-${order.orderBy}.png`}
								alt={`추가`}
								style={{
									width: "1.1em",
									height: "1.1em",
								}}
							/>
						</span>
					),
					dataIndex: "created_at",
					key: "created_at",
					width: "15%",
					ellipsis: true,
					// className: "text-right",
					render: (value) => {
						return <>{moment(value).format("YY. M. D.")}</>;
					},
				},
				{
					title: () => (
						<span
							onClick={() => {
								if (order.orderType !== "product_count") {
									setOrder({
										...order,
										orderType: "product_count",
									});
								} else {
									setOrder({
										orderType: "product_count",
										orderBy: order.orderBy === "desc" ? "asc" : "desc",
									});
								}
							}}
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "flex-end",
								gap: "3px",
								cursor: "pointer",
							}}
						>
							{order.orderType === "product_count" ? <b>클릭수</b> : "클릭수"}
							<img
								src={`/assets/images/products/dropdown-${order.orderBy}.png`}
								alt={`추가`}
								style={{
									width: "1.1em",
									height: "1.1em",
								}}
							/>
						</span>
					),
					dataIndex: "product_count",
					key: "product_count",
					width: "15%",
					ellipsis: true,
					className: "text-right",
				},
				// {
				//     title: '댓글',
				//     dataIndex: 'comment_num',
				//     key: 'comment_num',
				//     width: "15%",
				//     ellipsis: true,
				//     className: "text-right",
				// },
		  ];

	const dropdownItems = (
		<Menu>
			<Menu.Item
				style={{ fontSize: "0.9em" }}
				onClick={() => {
					setOrder({
						...order,
						orderType: "created_at",
						orderBy: "desc",
					});
				}}
			>
				최신순
			</Menu.Item>
			<Menu.Item
				style={{ fontSize: "0.9em" }}
				onClick={() => {
					setOrder({
						...order,
						orderType: "product_count",
						orderBy: "desc",
					});
				}}
			>
				클릭수
			</Menu.Item>
		</Menu>
	);

	const mobileFilter = () => {
		return (
			<Dropdown overlay={dropdownItems} trigger={"click"}>
				<Button
					size={`small`}
					style={{
						fontSize: "0.9em",
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						width: "10em",
						marginLeft: "auto",
					}}
				>
					{order.orderType === "created_at" ? "최신순" : "조회순"}
					<img
						src={`/assets/images/report/dropdown.png`}
						alt={`드롭다운`}
						style={{
							height: "auto",
							width: "0.8em",
						}}
					/>
				</Button>
			</Dropdown>
		);
	};

	return (
		<div className="main-wrap">
			<div className="max-width-apply">
				<LinkComponent />
				<h1 className="main-title">
					{/*판매・정산*/}
					리포트
				</h1>

				<div className={`main-nav`}>
					<button
						className={`clicked`}
						onClick={() => {
							history.push(`/reports_analysis/category`);
						}}
					>
						채널 분석
					</button>
					<button onClick={() => history.push(`/reports`)}>판매</button>
					<button onClick={() => history.push(`/reports?level=settlement`)}>
						정산
					</button>
				</div>

				{/* 분석 navbar */}
				<AnalysisNav />

				<Table
					dataSource={productList}
					className="analysis-table-wrap"
					rowClassName={`analysis-table-row`}
					columns={analysisProductColumn}
					pagination={false}
					rowKey={"content_id"}
					loading={isLoading}
					showHeader={!mediaResult}
					title={mediaResult ? () => mobileFilter() : undefined}
					expandRowByClick
					// expandIcon={(e) => (
					//     <img
					//         src={`/assets/images/products/dropdown-${e.expanded ? "asc" : "desc"}.png`}
					//         alt={`추가`}
					//         style={{
					//             width: "1.1em",
					//             height: "1.1em"
					//         }}
					//         onClick={(e) => {
					//             e.target.parentElement?.parentElement?.parentElement?.click()
					//         }}
					//     />
					// )}
					// expandable={{
					//     expandedRowRender: record => (
					//         <AnalysisChart
					//             mediaResult={mediaResult}
					//             item={record}
					//         />
					//     ),
					//     rowExpandable: record => record.name !== "Not Expandable"
					// }}
				/>
				{/* 통계 차트 표기 */}
				<Pagination
					className="report-pagination-wrap"
					showSizeChanger={false}
					current={currentPageNumber}
					pageSize={pageSize}
					total={totalSize}
					onChange={handleChangePagination}
					disabled={isLoading}
				/>
			</div>
		</div>
	);
};

export default AnalysisProducts;
